<template>
  <div class="box"
       @click="closeLangList">
    <div class="Section">
      <div class="Header">
        <div class="Header-logo"></div>
        <div class="Header-title">{{ $t(`nav.title`) }}</div>
<!--        <div class="lang-btn"-->
<!--             @click.stop="getLangList">-->
<!--          <span class="lang-current">{{ currentLang }}</span>-->
<!--          <i class="Header-select-logo"></i>-->
<!--        </div>-->
<!--        <div class="lang-list"-->
<!--             v-if="langListShow">-->
<!--        <span-->
<!--            v-for="(value, key) in langMap"-->
<!--            :key="key"-->
<!--            @click="changeLang(key)"-->
<!--            class="lang-selector"-->
<!--        >-->
<!--      {{ value }}-->
<!--    </span>-->
<!--        </div>-->
      </div>
      <a :href="this.appleStoreLink"
         target="_blank"
         @click="appleBtnADS">
        <img class="Apple-store"
             :class="'store-' + lang"
             :src="appleStoreBg"
             alt="" />
      </a>
      <a
          :href="this.googlePlayLink"
          target="_blank"
          @click="googleBtnADS">
        <img class="Google-store"
             :class="'store-' + lang"
             :src="googlePlayBg"
             alt="" />
      </a>
    </div>


<!--    <div class="p2">-->
<!--      <img class="p2-title"-->
<!--           :src="title"-->
<!--           :class="lang + '-title'" />-->
<!--    </div>-->
<!--    <div class="swiper-container" ref="p5swiper">-->
<!--      <div class="swiper-wrapper">-->
<!--        <div class="swiper-slide"-->
<!--             v-for="item in imgsMoUrl"-->
<!--             :key="item.index">-->
<!--          <div class="swiperimg"-->
<!--               :style="{-->
<!--              'background-image': 'url(' + item.url + ')',-->
<!--              'background-size': '100% 100%',-->
<!--            }"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="swiper-pagination"></div>-->
<!--      <div class="swiper-button-prev"></div>-->
<!--      <div class="swiper-button-next"></div>-->
<!--    </div>-->
    <div id="footer">
      <div><a target="_blank" :href="$t(`footer.privacy-url`)">{{  $t(`footer.privacy`) }}</a> | <a target="_blank" :href="$t(`footer.terms-url`)">{{  $t(`footer.terms`) }}</a></div>
      <div>{{  $t(`footer.copyright`) }}</div>
      <div>{{  $t(`footer.owner`) }}</div>
    </div>
  </div>
</template>
<script>
import { linkApi, getCesMoimgs } from '../api/index'
import Swiper from '../utils/swiper4.4.1/swiper'
import '../utils/swiper4.4.1/swiper.css'
export default {
  name: 'Home',
  data() {
    return {
      langListShow: false,
      langMap: {
        'en': "English",
        'ja': "JA",
        'ko': "KO",
        'ru': "RU",
        'tw': "ZH-TW",
        'th': "TH",
      },
      lang: '',
      imgsMoUrl: [],
      appleStoreLink: process.env.VUE_APP_APPLE_STORE_LINK || '',
      googlePlayLink: process.env.VUE_APP_GOOGLE_STORE_LINK || '',
      swiper: null,
    }
  },
  computed: {
    currentLang: function () {
      return this.langMap[this.lang];
    },
    text: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/text.png')
          break
        case 'ru':
          return require('../assets/imgs/ru/text.png')
          break
        case 'ko':
          return require('../assets/imgs/ko/text.png')
          break
        case 'ja':
          return require('../assets/imgs/ja/text.png')
          break
        case 'th':
          return require('../assets/imgs/th/text.png')
          break
        case 'tw':
          return require('../assets/imgs/tw/text.png')
          break
      }
    },
    appleStoreBg: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/appleStoreBg.png')
          break
        case 'ru':
          return require('../assets/imgs/ru/appleStoreBg.png')
          break
        case 'ko':
          return require('../assets/imgs/ko/appleStoreBg.png')
          break
        case 'ja':
          return require('../assets/imgs/ja/appleStoreBg.png')
          break
        case 'tw':
          return require('../assets/imgs/tw/appleStoreBg.png')
          break
        case 'th':
          return require('../assets/imgs/th/appleStoreBg.png')
          break
      }
    },
    googlePlayBg: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/googlePlayBg.png')
          break
        case 'ru':
          return require('../assets/imgs/ru/googlePlayBg.png')
          break
        case 'tw':
          return require('../assets/imgs/tw/googlePlayBg.png')
          break
        case 'th':
          return require('../assets/imgs/th/googlePlayBg.png')
          break
        case 'ja':
          return require('../assets/imgs/ja/googlePlayBg.png')
          break
        case 'ko':
          return require('../assets/imgs/ko/googlePlayBg.png')
          break
      }
    },
    title: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/title.png')
          break
        case 'ru':
          return require('../assets/imgs/ru/title.png')
          break
        case 'ko':
          return require('../assets/imgs/ko/title.png')
          break
        case 'tw':
          return require('../assets/imgs/tw/title.png')
          break
        case 'th':
          return require('../assets/imgs/th/title.png')
          break
        case 'ja':
          return require('../assets/imgs/ja/title.png')
          break

      }
    },
    logo: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/logo.png')
          break
        case 'ru':
          return require('../assets/imgs/ru/logo.png')
          break
        case 'ko':
          return require('../assets/imgs/ko/logo.png')
          break
        case 'tw':
          return require('../assets/imgs/tw/logo.png')
          break
        case 'th':
          return require('../assets/imgs/th/logo.png')
          break
        case 'ja':
          return require('../assets/imgs/ja/logo.png')
          break

      }
    },
  },
  methods: {
    changeLang(url) {
      this.langListShow = false
      this.$router.push({ path: url })
          .then(() => {
            this.initLang()
            this.getImgsinfo()
            // 不使用完全刷新，而是通过组件内部更新状态
          })
          .catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('导航错误:', err)
            } else {
              this.initLang()
              this.getImgsinfo()
            }
          })
    },
    closeLangList() {
      this.langListShow = false
    },
    getLangList() {
      this.langListShow = !this.langListShow
    },
    navigatorLanguage() {
    let navigatorLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();
    let curentLang = "en";
    // if (navigatorLanguage.indexOf("en") > -1) {
    //   curentLang = "en";
    // }
    // if (navigatorLanguage.indexOf("ja") > -1) {
    //   curentLang = "ja";
    // }
    // if (navigatorLanguage.indexOf("ko") > -1) {
    //   curentLang = "ko";
    // }
    // if (navigatorLanguage.indexOf("ru") > -1) {
    //   curentLang = "ru";
    // }
    // if (navigatorLanguage.indexOf("tw") > -1) {
    //   curentLang = "tw";
    // }
    // if (navigatorLanguage.indexOf("th") > -1) {
    //   curentLang = "th";
    // }
    // if (navigatorLanguage.indexOf("pt") > -1) {
    //   curentLang = "pt";
    // }
    return curentLang;
  },
    initLang() {
      switch (this.$route.path.replace('/', '')) {
        case 'en':
          this.lang = 'en'
          break
        case 'ru':
          this.lang = 'ru'
          break
        case 'tw':
          this.lang = 'tw'
          break
        case 'ko':
          this.lang = 'ko'
          break
        case 'ja':
          this.lang = 'ja'
          break
        case 'th':
          this.lang = 'th'
          break
      }
      if (this.lang === '') {
        this.changeLang(this.navigatorLanguage());
      }
      localStorage.setItem("locale", this.lang);
    },
    initSwiiperM() {
      const options = {
        effect: 'coverflow',
        slidesPerView: 'auto',
        roundLengths: true,
        loop: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          autoplay: true,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 8,
          stretch: 20,
          depth: 30,
          modifier: 2,
          slideShadows: false,
        },
      }
      if (this.swiper) {
        this.swiper.destroy(true, true) //删除之前创建的swiper实例
      }
      this.swiper = new Swiper(this.$refs.p5swiper, options)
    },
    appleBtnADS() {
      if (window.location.href.indexOf('utm_source=fb') !== -1) {
        fbq('track', 'AddToCart');
      }
      if (window.location.href.indexOf('utm_source=tiktok') !== -1) {
        ttq.track('ClickButton');
      }
      // if (window.location.href.indexOf('utm_source=google') !== -1) {
      //   window.gtag_report_conversion()
      //   window.gtag('config', 'AW-16638454849/zccdCKb-utQaEMHY6v09')
      //   window.gtag('js', new Date())
      // }
    },
    googleBtnADS() {
      if (window.location.href.indexOf('utm_source=fb') !== -1) {
        fbq('track', 'CompleteRegistration');
      }
      if (window.location.href.indexOf('utm_source=tiktok') !== -1) {
        ttq.track('AddToWishlist');
      }
    },
    googlegtag() {
      if (window.location.href.indexOf('utm_source=google') !== -1) {
        window.gtag('config', 'AW-16638454849')
        window.gtag('js', new Date())
      }
    },
    getImgsinfo() {
      let _this = this
      let id = function () {
        switch (_this.lang) {
          case 'en':
            return process.env.VUE_APP_EN_ID || 300066238981105
            break
          case 'ru':
            return process.env.VUE_APP_RU_ID || 300066238981105
            break
          case 'tw':
            return process.env.VUE_APP_TW_ID || 300066238981105
            break
          case 'ko':
            return process.env.VUE_APP_KO_ID || 300066238981105
            break
          case 'ja':
            return process.env.VUE_APP_JA_ID || 300066238981105
            break
          case 'th':
            return process.env.VUE_APP_TH_ID || 300066238981105
            break
          default :
            return process.env.VUE_APP_EN_ID || 300066238981105
            break
        }
      }
      const params1 = {
        id: id(),
      }
      this.imgsMoUrl = []
      getCesMoimgs(params1).then((res) => {
        this.imgsMoUrl = res.data.result.content
        setTimeout(() => {
          this.initSwiiperM()
        }, 100)
      })
    },
  },
  mounted() {
    // this.getImgsinfo()
  },
  created() {
    this.initLang()
    window.px2rem()
    // this.googlegtag()
  },
}
</script>
<style scoped>
a {
  z-index: 3;
}
.Section {
  position: relative;
  width: 7.5rem;
  height: 13.34rem;
  background: url('~@/assets/imgs/bg.png') no-repeat;
  background-size: 100% 100%;
}
.lang-list {
  height: 3rem;
  width: 1.9rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  right: 0.3rem;
  top: 0.75rem;
  bottom: -1.68rem;
  background-color: rgba(2, 2, 2, 0.6);
}
.lang-list span {
  font-size: 0.32rem;
  color: #e1e0e0;
}
.lang-btn {
  position: absolute;
  right: 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 0.1rem;
  background: linear-gradient(180deg, #a37349, #ecdda3);
  border: 0.01rem solid #ddc690;
  border-radius: 0.1rem;
  height: 0.55rem;
}
.Header {
  height: 0.9rem;
  width: 7.5rem;
  background: black;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
}
.Header-logo{
  margin-left: 0.2rem;
  border-radius: 0.15rem;
  width: 0.7rem;
  height: 0.7rem;
  background-size: cover;
  background: url('~@/assets/imgs/logo.png') no-repeat center;
  background-size: 100% 100%;
}
.Header-title{
  position: absolute;
  left: 1.05rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #ced4d5;
  font-size: 0.24rem;
}
.lang-current {
  width: 1.5rem;
  text-align: center;
  font-size: 0.32rem;
  color: #70421a;
  text-shadow: #d2b783 0.01rem 0 0.01rem,#d2b783 -0.01rem 0 0.01rem,#d2b783 0 -0.01rem 0.01rem,#d2b783 0 0.01rem 0.01rem;
}
.Header-select-logo {
  display: inline-block;
  width: 0.28rem;
  height: 0.25rem;
  background: url('~@/assets/imgs/triangle.png');
  background-size: 100% 100%;
}
.Apple-store {
  float: left;
  position: absolute;
  top: 11.25rem;
  left: 0.53rem;
  right: 1.53rem;
}
.store-en{
  width: 2.76rem;
  height: 0.7rem;
}
.store-ru{
  width: 2.7rem;
  height: 0.8rem;
}
.store-ja{
  width: 2.7rem;
  height: 0.8rem;
}
.store-ko{
  width: 2.7rem;
  height: 0.8rem;
}
.store-tw{
  width: 2.7rem;
  height: 0.8rem;
}
.store-th{
  width: 2.7rem;
  height: 0.8rem;
}
.Google-store {
  float: right;
  position: absolute;
  top: 11.25rem;
  left: 3.99rem;
  right: 1.53rem;
}

.p2 {
  width: 7.5rem;
  height: 13.34rem;
  background-size: 100% 100% !important;
  background: url('~@/assets/bg2.jpg');
}
.p2-title {
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.en-title {
  width: 4.22rem;
  height: 1.02rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.ja-title {
  width: 2.03rem;
  height: 1.19rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.ko-title {
  width: 4.88rem;
  height: 1.01rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.ru-title {
  width: 4.54rem;
  height: 0.88rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.tw-title {
  width: 3.4rem;
  height: 1.14rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.th-title {
  width: 4.25rem;
  height: 1rem;
  position: absolute;
  top: 13.8rem;
  left: 50%;
  transform: translateX(-50%);
}

.swiper-container {
  position: absolute;
  float: left;
  height: 10.65rem;
  width: 7.2rem;
  top: 15.5rem;
  left: 0.15rem;
}
.swiper-wrapper {
  float: left;
  height: 10rem;
  width: 6.1rem;
}
.swiper-slide {
  background: url('~@/assets/imgs/swiper-slide.png') no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-pagination {
  width: 3rem;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  bottom: 0rem;
  left: 50%;
  transform: translateX(-50%);
}
.swiperimg {
  display: block;
  height: 100%;
  width: 100%;
}
.swiper-button-next{
  margin-right: -0.2rem;
  background: url('~@/assets/imgs/next-btn.png') no-repeat;
  background-size: 100% 100%;
  height: 1.12rem;
  width: 0.48rem;
}
.swiper-button-prev{
  margin-left: -0.2rem;
  background: url('~@/assets/imgs/pre-btn.png') no-repeat;
  background-size: 100% 100%;
  height: 1.12rem;
  width: 0.48rem;
}
#footer {
  position: absolute;
  top: 12.5rem;
  width: 7.5rem;
  display: flex;
  font-size: 0.14rem;
  color: #ced4d5;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
#footer a{
  color: #ced4d5;
}
#footer a:visited{
  color: #ced4d5;
}
#footer a:hover{
  color: #ced4d5;
}
#footer a:link{
  color: #ced4d5;
}
</style>
<style>

.swiper-pagination-bullet {
  width: 0.25rem;
  height: 0.25rem;
  background: url('~@/assets/imgs/pagination-bullet.png') no-repeat;
  background-size: contain;
  border-radius: 0;
}
.swiper-pagination-bullet-active {
  width: 0.25rem;
  height: 0.25rem;
  background: url('~@/assets/imgs/pagination-bullet-active.png') no-repeat;
  background-size: contain;
  border-radius: 0;
}
</style>
